import { PaymentMethodType } from '@nemuru-eng/js-api-client';

import { CardPaymentProviderLogos } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/components/CardPaymentProviderLogos';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

export const ConditionsDescriptionFactory = ({ paymentMethodType }: { paymentMethodType: PaymentMethodType }) => {
  switch (paymentMethodType) {
    case PaymentMethodType.CARD_PAYMENT:
      return (
        <FlexRow>
          <Font variant="h4" color="title">
            <Text tId="IN_ONE_CARD_PAYMENT" />
          </Font>
          <CardPaymentProviderLogos />
        </FlexRow>
      );
    case PaymentMethodType.A2A_PAYMENT:
      return (
        <FlexRow>
          <Font variant="h4" color="title">
            <Text tId="IN_ONE_A2A_PAYMENT" />
          </Font>
        </FlexRow>
      );
    default:
      return null;
  }
};
